<template>
  <ul class="menuItems mr-0 mr-md-4">
    <li v-for="(item, i) in items" :key="i">
      <router-link :to="item.link" :exact="isHomeLink(item.link)">
        {{ item.title.toLocaleUpperCase("TR") }}
      </router-link>
    </li>
    <li>
      <a href="https://kurumsal.uteakademi.com">KURUMSAL</a>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      items: [
        // {
        //   title: "Ana Sayfa",
        //   link: "/"
        // },
        // {
        //   title: "Hakkımızda",
        //   link: "/about"
        // }
        {
          title: "EĞİTİMLERİMİZ",
          link: "/catalog"
        },
        {
          title: "SERTİFİKASYON",
          link: "/certification"
        }
        // ,{
        //   title: "KARİYER REHBERİ",
        //   link: "/career"
        // }
      ]
    };
  },
  computed: {
    userSignedIn() {
      return this.$store.getters["auth/userSignedIn"];
    }
  },
  methods: {
    setLinkClasses(link) {
      return {
        "router-link-active": link === this.$route.path
      };
    },
    isHomeLink(link) {
      return link === "/";
    }
  }
};
</script>
